import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { applyUpdate, onUpdateWaiting } from '../../serviceWorkerRegistration';

const TOAST_ID = 'app-update-available';

/**
 * Offers the new build once the service worker has installed it.
 *
 * It asks rather than reloading on its own: a vendor halfway through a
 * product edit or an import would lose it. The toast stays until acted on.
 */
const AppUpdateToast = () => {
    const { t } = useTranslation();

    useEffect(
        () =>
            onUpdateWaiting((registration) => {
                toast.message(t('APP_UPDATE.TITLE'), {
                    id: TOAST_ID,
                    description: t('APP_UPDATE.DESCRIPTION'),
                    duration: Infinity,
                    action: {
                        label: t('APP_UPDATE.RELOAD'),
                        onClick: () => applyUpdate(registration),
                    },
                });
            }),
        [t],
    );

    return null;
};

export default AppUpdateToast;
